import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import ArrayUtil from '../../../../../utils/ArrayUtil';
import {
  LegacyInputTextComponent,
  DropdownWithValidation,
  PrimeReactErrorMessage,
} from '../../../../../components/prime-formik';
import { formikFormShape } from '../../../../../components/prop-types';
import FormCheckboxGroup from '../../../../../components/formik-components/FormCheckboxGroup';

const i18n = defineMessages({
  title: {
    id: 'attrs.title',
    defaultMessage: 'Title',
  },
});

export const General = () => {
  const { formatMessage } = useIntl();

  const titlePlaceholder = formatMessage(i18n.title);

  return (
    <div className="p-grid p-fluid">
      <div className="p-col-6">
        <div className="form-group" key="title">
          <FormattedMessage
            tagName="label"
            htmlFor="title"
            className="field-label"
            id="attrs.title"
            defaultMessage="Title"
          />
          <Field id="title" name="title" component={LegacyInputTextComponent} placeholder={titlePlaceholder} />
        </div>
      </div>
    </div>
  );
};

export const EmailTemplates = (props) => {
  const { templates } = props;
  const invites = templates.invites.map(temp => ({
    value: temp.id,
    label: temp.name,
  }));

  const thanks = templates.thanks.map(temp => ({
    value: temp.id,
    label: temp.name,
  }));

  const reminders = templates.reminders.map(temp => ({
    value: temp.id,
    label: temp.name,
  }));

  const feedbacks = templates.feedbacks.map(temp => ({
    value: temp.id,
    label: temp.name,
  }));
  return (
    <div className="p-col-12">
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <h3 className="section-title no-margin" key="title">
            <FormattedMessage id="attrs.email_templates" defaultMessage="Email Templates" />
          </h3>
        </div>
        <div className="p-col-6 form-group email-template align-bottom" key="invite">
          <label className="field-label" htmlFor="inviteTemplateId">
            <FormattedMessage id="attrs.invite_email_template" defaultMessage="Invite Email Template" />
          </label>
          <Field id="invite" name="inviteTemplateId" component={DropdownWithValidation} options={invites} />
        </div>
        <div className="p-col-6 form-group email-template align-bottom" key="thank">
          <label className="field-label" htmlFor="thankYouTemplateId">
            <FormattedMessage id="attrs.thank_email_template" defaultMessage="Thank You Email Template" />
          </label>
          <Field id="thankyou" name="thankYouTemplateId" component={DropdownWithValidation} options={thanks} />
        </div>
        <div className="p-col-6 form-group email-template align-bottom" key="reminder">
          <label className="field-label" htmlFor="reminderTemplateId">
            <FormattedMessage id="attrs.reminder_email_template" defaultMessage="Reminder Email Template" />
          </label>
          <Field id="reminder" name="reminderTemplateId" component={DropdownWithValidation} options={reminders} />
        </div>
        <div className="p-col-6 form-group email-template align-bottom" key="feedback">
          <label className="field-label" htmlFor="feedbackTemplateId">
            <FormattedMessage id="attrs.feedback_email_template" defaultMessage="Feedback Email Template" />
          </label>
          <Field id="feedback" name="feedbackTemplateId" component={DropdownWithValidation} options={feedbacks} />
        </div>
      </div>
    </div>
  );
};

EmailTemplates.propTypes = {
  templates: PropTypes.objectOf(PropTypes.any).isRequired,
};

const generateCompetencyGroup = (groups, setFieldValue) => {
  const compGroupList = groups.map((group, i) => {
    const dimList = group.map((comp) => {
      const fieldData = ArrayUtil.isNotEmpty(comp.abilities)
        ? comp.abilities.map(ab => ({
          value: ab.id,
          label: ab.displayName,
        }))
        : [];
      return (
        <div className="p-md-3 p-sm-6 p-xs-12" key={comp.id}>
          <Field
            name="abilities"
            options={fieldData}
            setFieldValue={setFieldValue}
            component={FormCheckboxGroup}
            displayName={comp.displayName}
            isErrorShown={false}
          />
        </div>
      );
    });
    return (
      // eslint-disable-next-line react/no-array-index-key
      <div key={i} className="p-col-12">
        <div className="p-grid p-fluid">{dimList}</div>
      </div>
    );
  });

  return compGroupList;
};

export const Dimensions = (props) => {
  const {
    competencies,
    formProps: { setFieldValue, errors },
  } = props;
  const competencyGroup = ArrayUtil.chunk(competencies, 4);
  const generatedCompetencies = generateCompetencyGroup(competencyGroup, setFieldValue);
  return (
    <div className="p-grid">
      <div className="p-col-12">
        <h3 className="section-title no-margin" key="section-title">
          <FormattedMessage id="attrs.competencies" defaultMessage="Competencies" />
        </h3>
        {errors && errors.abilities && <PrimeReactErrorMessage msg={errors.abilities} />}
      </div>
      <div className="p-col-12 dimension-section" key="dimensions">
        <div className="p-grid">{generatedCompetencies}</div>
      </div>
    </div>
  );
};

Dimensions.propTypes = {
  competencies: PropTypes.arrayOf(PropTypes.any).isRequired,
  formProps: formikFormShape.isRequired,
};
